import React from "react";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { ChevronLeftIcon, ChevronRightIcon } from "assets/img";
import { DatePicker } from "components";

dayjs.extend(weekday);
dayjs.extend(weekOfYear);

const WeekPicker = ({
  width,
  dayPicker = false,
  onDateChange,
  currentDate,
  setCurrentDate,
}) => {
  const goToNextWeek = () => {
    const newDate = dayjs(currentDate).add(1, dayPicker ? "day" : "week");
    setCurrentDate(newDate);
    onDateChange(newDate);
  };

  const goToPrevWeek = () => {
    const newDate = dayjs(currentDate).subtract(1, dayPicker ? "day" : "week");
    setCurrentDate(newDate);
    onDateChange(newDate);
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center" }}
      className={`${
        width ?? ""
      } flex flex-row items-center justify-center rounded-lg`}
    >
      <button
        onClick={goToPrevWeek}
        className="flex bg-light-gray justify-start py-[13px] px-[16px] rounded-xl"
      >
        <img src={ChevronLeftIcon} className="h-[20px] w-[20px]" />
      </button>

      <DatePicker
        selectedDate={currentDate?.toDate()}
        placeholderText="Select start date"
        className="flex justify-between mx-2 items-center bg-light-gray rounded-xl"
        pickerClassName="font-inter-medium py-[12px] text-center"
        showIcon={false}
        dateFormat={"eee, MMM dd, yyyy"}
        setSelectedDate={(date) => {
          const newDay = dayjs(date);
          setCurrentDate(newDay);
          onDateChange?.(newDay);
        }}
        isHome={true}
        isInvoice={true}
      />

      <button
        onClick={goToNextWeek}
        className="flex bg-light-gray justify-start py-[13px] px-[16px] rounded-xl"
      >
        <img src={ChevronRightIcon} className="h-[20px] w-[20px]" />
      </button>

      {!dayjs(currentDate).isSame(dayjs(), "day") && (
        <button
          onClick={() => {
            const today = dayjs();
            setCurrentDate(today);
            onDateChange?.(today);
          }}
          className="text-catering font-inter-medium text-[14px] pl-[12px] hover:text-blue-700 cursor-pointer"
        >
          Go back to today
        </button>
      )}
    </div>
  );
};

export default WeekPicker;
